import { WidgetsIdsMain } from '@/widgets/ids';

export const PagesIdsMain = () => <WidgetsIdsMain />;
